<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'document-upload-step3.pageTitle' | translate }}
			</div>
		</div>
		<!-- CARD -->
		<div class="col-12 col-xl-12">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line p-4">
				<div class="upload-bar-title fw-6">{{ 'document-upload-step3.UploadDocStateLineTitle' | translate }}</div>
				<div class="d-flex col-12 upload-status-content">
					<eif-custom-upload-state-bar
						[countValidRecords]="totalValidRecords"
						[countInvalidRecords]="totalInvalidRecords">
					</eif-custom-upload-state-bar>
					<eif-upload-doc-amounts-per-currency
						[validSumAmountPerCurrency]="validSumAmountPerCurrency"
						[invalidSumAmountPerCurrency]="invalidSumAmountPerCurrency">
					</eif-upload-doc-amounts-per-currency>
				</div>
				@if (showValidationResultsForConfirming()) {
					<eif-documents-upload-confirming-validation-result
						[validationResultRecords]="validationResultRecords"
						[pagination]="tablePagination"
						[loading]="isPerformingRequest || isTableLoading"
						[filters]="tableFilters"
						[enableFilters]="true"
						[showPageSize]="true"
						(searchRequested)="onSearchRequested($event)">
					</eif-documents-upload-confirming-validation-result>
				}
				@if (showValidationResultsForFactoring()) {
					<eif-documents-upload-factoring-validation-result
						[validationResultRecords]="validationResultRecords"
						[pagination]="tablePagination"
						[loading]="isPerformingRequest || isTableLoading"
						[filters]="tableFilters"
						[enableFilters]="true"
						[showPageSize]="true"
						(searchRequested)="onSearchRequested($event)">
					</eif-documents-upload-factoring-validation-result>
				}
			</div>

			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex flex-grow-1">
					<a
						role="button"
						class="is-color-primary"
						(click)="openInstructionsModal()">
						<i class="fa-solid fa-info-circle me-2"></i>
						{{ 'document-upload-step3.howToUpload' | translate }}
					</a>
				</div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end py-4 gap-3">
					<eif-custom-button
						[color]="'neutral'"
						[text]="'button.back' | translate"
						(action)="redirectToDocumentsStep2()">
					</eif-custom-button>
					@if (hasEnteredRequiredData()) {
						<eif-custom-button
							[text]="'document-upload-step3.goToResumeStep' | translate"
							(action)="submitRecords()">
						</eif-custom-button>
					}
				</div>
			</div>
		</div>
	</div>
</div>
